import React from "react";
import { DiscoverWrap, Title, Text, TextTitle, Column, Content, ImageWrap, TextComing } from "./styled";
import Image from "next/image";

const Discover = () => {
  return (
    <DiscoverWrap>
      <Title>Be Discovered</Title>
      <Content>
        <Column>
          <ImageWrap>
            <Image src={`/images/browsing.png`} alt="Browsing" layout="fill" objectFit="cover" quality={100} />
          </ImageWrap>
          <Text>
            <TextTitle>Browsing</TextTitle>
            Gorgeous, easy browsing for Foody visitors to discover your recipes and collections.
          </Text>
        </Column>
        <Column>
          <ImageWrap>
            <Image src={`/images/sharing.png`} alt="Sharing" layout="fill" objectFit="cover" quality={100} />
          </ImageWrap>
          <Text>
            <TextTitle>Sharing</TextTitle>
            Recipes and collections that can easily be shared to friends.
          </Text>
        </Column>
        <Column>
          <ImageWrap>
            <Image
              src={`/images/notifications.png`}
              alt="Notifications"
              layout="fill"
              objectFit="cover"
              quality={100}
            />
          </ImageWrap>
          <Text>
            <TextTitle>Notifications</TextTitle>
            Customers and fans get notified of your new collections, recipes and other projects
            <TextComing>Coming Soon</TextComing>
          </Text>
        </Column>
      </Content>
    </DiscoverWrap>
  );
};

export default Discover;
